import React from "react";
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styles from "./index.module.scss";
import {useDevice} from "@/hooks";
import LazyMedia from "@/components/LazyMedia";
const iphone1 = require('../../assets/iphone1.png')
const iphone2 = require('../../assets/iphone2.png')
const iphone3 = require('../../assets/iphone3.png')
const iphone4 = require('../../assets/iphone4.png')
const iphone5 = require('../../assets/iphone5.png')
const iphone6 = require('../../assets/iphone6.png')
const iphone7 = require('../../assets/iphone7.png')
const iphone8 = require('../../assets/iphone8.png')
const iphone9 = require('../../assets/iphone9.png')
interface software{
  words: Record<string, string>;
}
const IphoneOne:React.FC<software> = ({words})=> {
  const location = useLocation();
  const boxRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  // 记录滚动元素是否进入可视区域
  const [isBoxAnimate, setIsBoxAnimate] = useState(false);
  useEffect(() => {
    let observer: IntersectionObserver
    // 判断记录的元素是否进入过可视区域
    if (!isBoxAnimate) {
      // 不在可视区域，开始监听元素
      observer = new IntersectionObserver(
          ([entry]) => {
            // 元素进入可视区域，执行动画
            setIsVisible(entry.isIntersecting);
            setIsBoxAnimate(true);
            // 元素进入可视区域后，取消监听元素
            entry.intersectionRatio > 0 && observer.unobserve(boxRef.current)
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 0.1, // 当目标元素的可见性至少达到 threshold 值时触发回调函数
          }
      );
      if (boxRef.current) {
        observer.observe(boxRef.current);
      }
    }
    // 取消观察
    return () => {
      observer.unobserve(boxRef.current);
    };
  }, [boxRef]);
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView();
      }
    }
  }, [location]);
  // 判断不同屏幕下手机图片是否展示
  const device = useDevice();
    return (
      <>
      <div className={styles.downloadIphone} id="applications" ref={boxRef}>
        <div className={styles.downloadTittle}>
            <div className={`${styles.Tittle}${styles.textTittleM}`}>
              <p className={`${styles.textTittle}${!isVisible?styles.textTittleKey:''}`}>{words.software_Applications_title}</p>
            </div>
            <div className={styles.Tittle}>
              <p className={`${styles.textContent}${!isVisible?styles.textContentKey:''}`}>{words.software_Applications_content}</p>
            </div>
        </div>
        <div className={styles.iphoneImg}>
          <div className={styles.iphone1}>
            {
              device === 'pc' ? <LazyMedia type="image" src={iphone1} className={`${styles.iphoneImg1}${!isVisible?styles.iphoneImg1Key:''}`}/> :  ''
            }
          </div>
          <div className={styles.iphone2}>
            {
              device === 'pc' || device === 'paid' ? <LazyMedia type="image" src={iphone2} className={`${styles.iphoneImg2}${!isVisible?styles.iphoneImg2Key:''}`}/>:  ''
            }
          </div>
          <div className={`${styles.iphone3}${!isVisible?styles.iphone3Key:''}`}>
            {
              device === 'pc'|| device === 'paid'  ? <LazyMedia type="image" src={iphone3} className={styles.iphoneImg3}/>:  ''
            }
            <img src={iphone4} className={styles.iphoneImg4}/>
            <img src={iphone5} className={styles.iphoneImg5}/>
            <img src={iphone6} className={styles.iphoneImg6}/>
            {
              device === 'pc'|| device === 'paid' ? <LazyMedia type="image" src={iphone8} className={styles.iphoneImg7}/>:  ''
            }
          </div>
          <div className={styles.iphone4}>
            {
              device === 'pc'|| device === 'paid' ? <LazyMedia type="image" src={iphone7} className={`${styles.iphoneImg8}${!isVisible?styles.iphoneImg8Key:''}`} />:  ''
            }
          </div>
          <div className={styles.iphone5}>
            {
              device === 'pc' ? <LazyMedia type="image" src={iphone9} className={`${styles.iphoneImg9}${!isVisible?styles.iphoneImg9Key:''}`}/>:  ''
            }
          </div>
        </div>
      </div>
      </>
    );
  };
  export default IphoneOne;
